// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_po-0";